// extracted by mini-css-extract-plugin
export default {"root":"ProgramTerms_root__CkeRk","lastUpdated":"ProgramTerms_lastUpdated__5erjz marketplaceBodyFontStyles"};